import { render, staticRenderFns } from "./SkillsActions.vue?vue&type=template&id=13df0afa&"
import script from "./SkillsActions.vue?vue&type=script&lang=js&"
export * from "./SkillsActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports